/*
 * Orbit Trends — Product + Collection Polish
 * Safe launch version:
 * - product image reveal
 * - card rise reveal
 * - collection back-scroll anchor restoration
 * - product-card click rescue only
 *
 * IMPORTANT: no layout-wide CSS injection here. Keep this file behaviour-only.
 */
(function () {
  'use strict';

  var CARD_SELECTOR = 'product-card, .product-card, .product-grid__item';
  var IMAGE_SELECTOR = 'product-card img, .product-card img, .product-grid__item img';

  function installFooterAlignmentFix() {
    if (document.getElementById('orbit-footer-alignment-fix-v1')) return;
    var style = document.createElement('style');
    style.id = 'orbit-footer-alignment-fix-v1';
    style.textContent = [
      'footer .shopify-section-group-footer-group, footer .shopify-section-group-footer-group .section-background, footer .shopify-section-group-footer-group .section{background:#141414!important}',
      'footer .footer-content{max-width:1120px!important;margin-inline:auto!important;display:grid!important;grid-template-columns:minmax(170px,.85fr) minmax(190px,.85fr) minmax(390px,1.3fr)!important;gap:clamp(40px,6vw,88px)!important;align-items:start!important;justify-content:center!important;padding-block:clamp(34px,4vw,50px) clamp(22px,3vw,34px)!important}',
      'footer .footer-content .menu,footer .footer-content .payment-icons{width:100%!important;max-width:none!important;justify-self:stretch!important}',
      'footer .menu__heading__default{margin:0 0 1.15rem!important;line-height:1!important}',
      'footer .menu .menu__item.paragraph{line-height:1.8!important}',
      'footer .menu .menu__item.paragraph a{min-height:0!important;padding:.16rem 0!important;line-height:1.45!important}',
      'footer .payment-icons::before{content:"Secure Payments";display:block;color:#9e9690;font-size:.6rem;font-weight:700;letter-spacing:.25em;line-height:1;margin:0 0 1.15rem;text-transform:uppercase}',
      'footer .payment-icons__list{display:flex!important;flex-flow:row nowrap!important;align-items:center!important;justify-content:flex-start!important;gap:7px!important;width:100%!important;margin:0!important;padding:0!important}',
      'footer .payment-icons__item,footer .payment-icons__item svg{width:36px!important;height:auto!important;flex:0 0 auto!important}',
      'footer .logo-section{padding-block:clamp(24px,3vw,34px)!important;border-top:1px solid rgba(240,236,230,.07)!important;border-bottom:1px solid rgba(240,236,230,.07)!important}',
      'footer .orbit-logo-link{max-width:min(520px,82vw)!important;margin-inline:auto!important}',
      'footer .utilities{padding-block:0 30px!important;gap:14px!important;text-align:center!important}',
      'footer .footer-utilities__group-copyright,footer .orbit-legal-footer-text{margin-inline:auto!important;text-align:center!important}',
      '@media(max-width:989px){footer .footer-content{grid-template-columns:1fr 1fr!important;max-width:720px!important;gap:34px 48px!important}footer .payment-icons{grid-column:1/-1!important}footer .payment-icons::before{text-align:center!important}footer .payment-icons__list{justify-content:center!important;flex-wrap:wrap!important}}',
      '@media(max-width:599px){footer .footer-content{grid-template-columns:1fr!important;max-width:360px!important;gap:26px!important;text-align:center!important}footer .menu__heading__default,footer .payment-icons::before{text-align:center!important}footer .logo-section{padding-block:26px!important}}'
      /* join with a space, NOT '\n': Shopify's CDN minifier once turned the
         \n escape into a literal newline inside the string literal, producing
         a SyntaxError that killed this whole file for every visitor. */
    ].join(' ');
    document.head.appendChild(style);
  }


  function installPolicyPopoverComfortFix() {
    if (document.getElementById('orbit-policy-popover-comfort-runtime')) return;
    var style = document.createElement('style');
    style.id = 'orbit-policy-popover-comfort-runtime';
    style.textContent = [
      '.terms-policies-popover,#terms-policies-popover{width:min(252px,calc(100vw - 56px))!important;min-width:min(252px,calc(100vw - 56px))!important;max-width:calc(100vw - 56px)!important;padding:10px 0!important;border:1px solid rgba(245,240,235,.28)!important;outline:0!important;border-radius:0!important;background:rgba(14,14,13,.98)!important;box-shadow:0 0 0 1px rgba(201,164,85,.08),0 18px 48px rgba(0,0,0,.38)!important;backdrop-filter:blur(14px) saturate(1.05)!important;-webkit-backdrop-filter:blur(14px) saturate(1.05)!important}',
      '.terms-policies-popover .policy_list,#terms-policies-popover .policy_list{width:100%!important;margin:0!important;padding:0!important}',
      '.terms-policies-popover .policy_list li,#terms-policies-popover .policy_list li{margin:0!important;border-top:1px solid rgba(245,240,235,.075)!important}',
      '.terms-policies-popover .policy_list li:first-child,#terms-policies-popover .policy_list li:first-child{border-top:0!important}',
      '.terms-policies-popover .policy_list a,#terms-policies-popover .policy_list a{display:block!important;width:100%!important;padding:13px 18px!important;box-sizing:border-box!important;font-size:.66rem!important;line-height:1.25!important;letter-spacing:.16em!important;color:rgba(245,240,235,.72)!important;text-align:left!important;white-space:normal!important;text-decoration:none!important}',
      '.terms-policies-popover .policy_list a:hover,#terms-policies-popover .policy_list a:hover,.terms-policies-popover .policy_list a:focus-visible,#terms-policies-popover .policy_list a:focus-visible{color:#f5f0eb!important;background:rgba(201,164,85,.08)!important}',
      '@media(max-width:390px){.terms-policies-popover,#terms-policies-popover{width:min(236px,calc(100vw - 44px))!important;min-width:min(236px,calc(100vw - 44px))!important;max-width:calc(100vw - 44px)!important}.terms-policies-popover .policy_list a,#terms-policies-popover .policy_list a{padding:12px 16px!important;font-size:.64rem!important;letter-spacing:.145em!important}}'
    ].join(' ');
    document.head.appendChild(style);
  }

  function markLoaded(img) {
    if (!(img instanceof HTMLImageElement)) return;
    img.classList.add('orbit-img-reveal');
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('is-loaded');
      return;
    }
    img.addEventListener('load', function () {
      img.classList.add('is-loaded');
    }, { once: true });
  }

  function initImages(root) {
    (root || document).querySelectorAll(IMAGE_SELECTOR).forEach(markLoaded);
  }

  // One observer shared by every card; creating one per appended node piled up hundreds on deep infinite scroll
  var cardRiseObserver = null;

  function getCardRiseObserver() {
    if (cardRiseObserver) return cardRiseObserver;
    cardRiseObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('orbit-card-rise-done');
        cardRiseObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    return cardRiseObserver;
  }

  function initCardRise(root) {
    var cards = Array.prototype.slice.call((root || document).querySelectorAll(CARD_SELECTOR));
    if (!cards.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cards.forEach(function (card) { card.classList.add('orbit-card-rise-done'); });
      return;
    }

    var io = getCardRiseObserver();

    cards.forEach(function (card, index) {
      if (card.classList.contains('orbit-card-rise-done')) return;
      card.classList.add('orbit-card-rise');
      card.style.setProperty('--orbit-card-rise-delay', Math.min(index % 12, 8) * 55 + 'ms');
      io.observe(card);
    });
  }

  function restoreProductMainIfHidden() {
    if (!/\/products\//.test(location.pathname)) return;
    document.querySelectorAll('main .shopify-section[id$="__main"]').forEach(function (section) {
      if (section.style && section.style.display === 'none') {
        section.style.display = '';
        section.removeAttribute('aria-hidden');
      }
    });
  }

  function hideEmptyReviewWidgets(root) {
    var scope = root || document;
    var candidates = Array.prototype.slice.call(scope.querySelectorAll('.jdgm-horizon-widget, .jdgm-widget, [class*="jdgm"], .shopify-app-block'));
    candidates.forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!text) return;
      var isEmptyReviewPrompt = text === 'no reviews' || text.indexOf('be the first to write a review') !== -1;
      if (!isEmptyReviewPrompt) return;

      var productMain = el.closest('main .shopify-section[id$="__main"]');
      if (productMain) {
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
        restoreProductMainIfHidden();
        return;
      }

      var section = el.closest('.shopify-section.section-wrapper, .shopify-section');
      (section || el).style.display = 'none';
      (section || el).setAttribute('aria-hidden', 'true');
    });
    restoreProductMainIfHidden();
  }

  function installProductCardClickRescue() {
    if (document.documentElement.dataset.orbitClickRescue === 'true') return;
    document.documentElement.dataset.orbitClickRescue = 'true';

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !(target instanceof Element)) return;
      if (target.closest('button, input, select, textarea, quick-add-component, quantity-selector, slideshow-controls, .product-badges, .badge')) return;

      var card = target.closest('product-card, .product-card, .product-grid__item');
      if (!card) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link || !(link instanceof HTMLAnchorElement)) return;
      if (target.closest('a') === link) return;

      event.preventDefault();
      event.stopPropagation();
      try {
        sessionStorage.setItem('orbit:lastCollectionAnchor', JSON.stringify({
          path: location.pathname,
          search: location.search,
          id: card.id || link.id || '',
          y: window.scrollY,
          t: Date.now()
        }));
      } catch (e) {}
      window.location.href = link.href;
    }, true);
  }

  function rememberCollectionAnchor(root) {
    (root || document).querySelectorAll('product-card a[href*="/products/"], .product-grid__item a[href*="/products/"]').forEach(function (link) {
      if (link.dataset.orbitAnchorReady === 'true') return;
      link.dataset.orbitAnchorReady = 'true';
      link.addEventListener('click', function () {
        var card = link.closest('.product-grid__item[id], product-card[id]');
        if (!card || !card.id) return;
        try {
          sessionStorage.setItem('orbit:lastCollectionAnchor', JSON.stringify({
            path: location.pathname,
            search: location.search,
            id: card.id,
            y: window.scrollY,
            t: Date.now()
          }));
        } catch (e) {}
      });
    });
  }

  function restoreCollectionAnchor() {
    var raw;
    try { raw = sessionStorage.getItem('orbit:lastCollectionAnchor'); } catch (e) { return; }
    if (!raw) return;

    var snap;
    try { snap = JSON.parse(raw); } catch (e) { return; }
    if (!snap || snap.path !== location.pathname || snap.search !== location.search || Date.now() - snap.t > 10 * 60 * 1000) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var el = document.getElementById(snap.id);
      if (el) {
        el.scrollIntoView({ block: 'center', behavior: 'instant' });
        window.clearInterval(timer);
        try { sessionStorage.removeItem('orbit:lastCollectionAnchor'); } catch (e) {}
      } else if (attempts > 30) {
        window.clearInterval(timer);
      }
    }, 120);
  }

  function init(root) {
    installFooterAlignmentFix();
    installPolicyPopoverComfortFix();
    restoreProductMainIfHidden();
    initImages(root);
    initCardRise(root);
    hideEmptyReviewWidgets(root);
    installProductCardClickRescue();
    rememberCollectionAnchor(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      restoreCollectionAnchor();
    });
  } else {
    init(document);
    restoreCollectionAnchor();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:reorder', function () { init(document); });

  // Batch added nodes into one pass per frame, skipping nodes nested inside another pending node,
  // instead of running every query synchronously for each inserted element.
  var pendingRoots = new Set();
  var flushScheduled = false;

  function flushPendingRoots() {
    flushScheduled = false;
    var roots = Array.from(pendingRoots);
    pendingRoots.clear();
    roots.forEach(function (node) {
      if (!node.isConnected) return;
      for (var i = 0; i < roots.length; i++) {
        if (roots[i] !== node && roots[i].contains(node)) return;
      }
      init(node);
    });
  }

  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node && node.nodeType === 1) pendingRoots.add(node);
      });
    });
    if (pendingRoots.size && !flushScheduled) {
      flushScheduled = true;
      requestAnimationFrame(flushPendingRoots);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
